// extracted by mini-css-extract-plugin
export default {"Bar":"SaveInVcBar_Bar__pSUMc","Title":"SaveInVcBar_Title__YOe5D","Actions":"SaveInVcBar_Actions__6Kgpm","Btn":"SaveInVcBar_Btn__i2yb6"};